var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "insta"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.00007 12.5556C9.94307 12.5556 10.8474 12.181 11.5142 11.5142C12.181 10.8474 12.5556 9.94307 12.5556 9.00007C12.5556 8.05708 12.181 7.15271 11.5142 6.48592C10.8474 5.81912 9.94307 5.44452 9.00007 5.44452C8.05708 5.44452 7.15271 5.81912 6.48592 6.48592C5.81912 7.15271 5.44452 8.05708 5.44452 9.00007C5.44452 9.94307 5.81912 10.8474 6.48592 11.5142C7.15271 12.181 8.05708 12.5556 9.00007 12.5556Z",
    stroke: "#383D38",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1 12.5556V5.44444C1 4.2657 1.46825 3.13524 2.30175 2.30175C3.13524 1.46825 4.2657 1 5.44444 1H12.5556C13.7343 1 14.8648 1.46825 15.6983 2.30175C16.5317 3.13524 17 4.2657 17 5.44444V12.5556C17 13.7343 16.5317 14.8648 15.6983 15.6983C14.8648 16.5317 13.7343 17 12.5556 17H5.44444C4.2657 17 3.13524 16.5317 2.30175 15.6983C1.46825 14.8648 1 13.7343 1 12.5556Z",
    stroke: "#383D38",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.8889 4.11995L13.8977 4.11017",
    stroke: "#383D38",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaLight);
export default __webpack_public_path__ + "static/media/insta-light.45cde44992bdc146d5c556656f97bfa9.svg";
export { ForwardRef as ReactComponent };